import classNames from 'classnames';
import { FC } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import theme from '~/constants/styles';
import './style.scss';

interface IProps {
  title?: string;
  className?: string;
  iconClassName?: string;
  onAdd?: () => void;
  iconSize?: number;
}

const AddButton: FC<IProps> = ({ title, className, onAdd, iconClassName, iconSize }: IProps): JSX.Element => {
  return (
    <button className={classNames('add-button', className)} onClick={onAdd}>
      <div className={classNames('add-button__icon', iconClassName)}>
        <Icon name={Icons.Plus} size={iconSize ?? 12} color={theme.colors.mainblue} />
      </div>
      {!!title && <p className="add-button__title">{localeStore.t(title)}</p>}
    </button>
  );
};

export default AddButton;
